import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {TombOfAkhenatenGameConfig} from "../TombOfAkhenatenGameConfig";
import {BitmapCountUp} from "@nolimitcity/slot-game/bin/core/component/BitmapCountUp";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TweenLite} from "gsap";
import {TOAGameEvent} from "../events/TOAGameEvent";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {GameModeEvent} from "@nolimitcity/slot-game/bin/core/gamemode/event/GameModeEvent";
import {TombOfAkhenatenGameMode} from "../gameMode/TombOfAkhenatenGameMode";
import {TombOfAkhenatenTextStyles} from "../config/TombOfAkhenatenTextStyles";
import {TombOfAkhenatenParsedGameData} from "../server/data/TombOfAkhenatenParsedGameData";
import {TombOfAkhenatenParsedInitData} from "../server/data/TombOfAkhenatenParsedInitData";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {SoundManager} from "../sound/SoundManager";
import {GameSetting} from "@nolimitcity/slot-game/bin/core/setting/GameSetting";

export class TOAMultiplier extends BaseView {
    //private _layer: ScalableLayer;
    private _fsWrapper: PIXI.Container;
    private _fsBgAnim: TimelineSprite;
    private _fsSmokeAnim: TimelineSprite;
    private _fsTextGlow: BitmapCountUp;
    private _fsText: BitmapCountUp;

    private _fsMultiplier:BitmapCountUp;
    private _isGameStarted: boolean = false;

    private _gameMode: string;
    private _gameData: TombOfAkhenatenParsedGameData | TombOfAkhenatenParsedInitData;
    constructor() {
        super();
    }

    protected addEventListeners(): void {
        EventHandler.addEventListener(this, TOAGameEvent.UPDATE_MULTIPLIER, (event: GameEvent) => this.updateMultiplier(event.params[0], event.params[1]));
        EventHandler.addEventListener(this, TOAGameEvent.RESET_MULTIPLIER, () => this.resetMultiplier());
        EventHandler.addEventListener(this, GameModeEvent.CHANGE_MODE, (event: GameModeEvent) => this.onModeChange(event.params[0].newMode));
        EventHandler.addEventListener(this, TOAGameEvent.ON_RESTORE, () => this.onRestore());
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event: GameEvent) => this.onDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event: GameEvent) => this.onDataParsed(event.params[0]));
        EventHandler.addEventListener(this, TOAGameEvent.ON_NEW_GAME_ROUND, () => this.onNewGameRound());
        EventHandler.addEventListener(this, TOAGameEvent.ON_GAME_START, () => this.onGameStart());
        EventHandler.addEventListener(this,"updateMultiForAS",(event: GameEvent)=>{
            if(event.params[0]>1){
                this._fsText.text="";
                this._fsText.text="x"+event.params[0];
                this._fsText.visible=true;
                this._fsTextGlow.visible=true;
                this._fsBgAnim.visible=true;
            }
        })
    }

    private onGameStart() {
        this._isGameStarted = true;
        this.onRestore();
    }

    protected initAnimations(): void {
        this.position.set(663, 40);
        this.name = "multContainer";
        this.createBonusGameGraphics();
        this.applyScaling();

        let layer:ScalableLayer = StageManager.getLayer(TombOfAkhenatenGameConfig.instance.LAYERS.STONE_PRESSER.name);
        layer.addChild(this);
        this.createFSMultiplier();
    }

    private static getSmokeAnimation(): TimelineSprite {
        let smokeAnimation: TimelineSprite = new TimelineSprite(GameResources.getTextures("multiplierUpInFS"), 30);

        smokeAnimation.name = "multUpAnim";
        smokeAnimation.anchor.set(0.5, 0.5);
        smokeAnimation.scale.set(1.1, 1.2);
        smokeAnimation.position.set(0, -4);
        smokeAnimation.visible = false;

        return smokeAnimation;
    }

    private createBonusGameGraphics(): void {
        this._fsWrapper = new PIXI.Container();
        this._fsWrapper.name = "bonusGameWrapper";

        this._fsBgAnim = new TimelineSprite(GameResources.getTextures("multiplierFsBg"), 30);
        this._fsBgAnim.name = "bonusBGAnim";
        this._fsBgAnim.anchor.set(0.5, 0.5);
        this._fsBgAnim.visible = false;

        this._fsSmokeAnim = TOAMultiplier.getSmokeAnimation();

        this._fsTextGlow = new BitmapCountUp({style: TombOfAkhenatenTextStyles.BONUS_GAME_MULTIPLIER_GLOW});
        this._fsTextGlow.pivot.set((this._fsTextGlow.width / this._fsTextGlow.text.length), this._fsTextGlow.height / 2);
        this._fsTextGlow.name = "textGlow";
        this._fsTextGlow.alpha = 0;

        this._fsText = new BitmapCountUp({style: TombOfAkhenatenTextStyles.BONUS_GAME_MULTIPLIER});
        this._fsText.pivot.set((this._fsText.width / this._fsText.text.length), this._fsText.height / 2);
        this._fsText.name = "text";
        this._fsText.visible = false;

        this._fsWrapper.addChild(this._fsBgAnim, this._fsSmokeAnim, this._fsTextGlow, this._fsText);
        this.addChild(this._fsWrapper);
    }

    private hideMultiplier(): void {
        this.applyScaling();
        this._fsText.visible = false;
        this._fsTextGlow.visible = false;
    }

    private showMultiplier(): void {
        this.applyScaling();

        let multiplierText = this._fsText,
            multiplierGlow = this._fsTextGlow;

        multiplierText.visible = true;
        multiplierGlow.visible = true;

        TweenLite.to(multiplierGlow, 1, {
            alpha: 1,
            delay: 1,
            onComplete: () => {
                TweenLite.to(multiplierGlow, 1, {
                    alpha: 0,
                    delay: 2
                });
            }
        });
    }

    private resetMultiplier(): void {
        this._fsText.text = "x" + TombOfAkhenatenGameConfig.instance.DEFAULT_MULTIPLIER;
        this._fsTextGlow.text = "x" + TombOfAkhenatenGameConfig.instance.DEFAULT_MULTIPLIER;
        this.hideMultiplier();
    }

    private applyScaling(): void {
        let textW = this._fsText.textWidth,
            posX: number;

        if (textW > 100) {
            this.scale.set(0.8);
            posX = -30;
        } else if (textW > 70) {
            this.scale.set(1);
            posX = -15;
        } else {
            this.scale.set(1);
            posX = 0;
        }

        this._fsText.position.set(posX, 0);
        this._fsTextGlow.position.set(posX, 0);
    }

    private updateMultiplier(value: number, isAbort: boolean): void {
        let indicatorValue: number = Number(this._fsText.text.split('x')[1]);

        if(this._gameMode === TombOfAkhenatenGameMode.NORMAL && !(TombOfAkhenatenGameConfig.instance.GAME_RESTORED)){
            return;
        }

        if (value === indicatorValue && !(TombOfAkhenatenGameConfig.instance.GAME_RESTORED)) {
            return;
        }

        if (value > 0) {
            this.updateFSMultiplier(value, isAbort);
        }
    }

    private onModeChange(mode: string): void {
        this._gameMode = mode;

        if (this.isBonusGame()) {
            this._fsWrapper.visible = true;
            this._fsBgAnim.playLoop();
            this._fsBgAnim.visible = true;

            if((this._gameData.mode === TombOfAkhenatenGameMode.NORMAL ||
                this._gameData.mode === TombOfAkhenatenGameMode.RESPIN_FIRST ||
                this._gameData.mode === TombOfAkhenatenGameMode.RESPIN_SECOND ||
                this._gameData.mode === TombOfAkhenatenGameMode.RESPIN_FINAL) && mode === TombOfAkhenatenGameMode.FREESPIN){
                this.updateMultiplier(this._gameData.payoutMultiplier, false);
            }
        } else {
            this._fsWrapper.visible = false;
            this._fsBgAnim.stopLoop();
            this._fsBgAnim.visible = false;
        }
    }

    private isBonusGame(): boolean {
        let flag = false;
        if (TombOfAkhenatenGameConfig.instance.BONUS_GAME_MODES.indexOf(this._gameMode) > -1) {
            flag = true;
        }
        return flag;
    }

    private onRestore(): void {
        //#410
        //this.updateMultiplier(this._gameData.payoutMultiplier, false);
        if(this.isBonusGame()){
            this._fsText.text = "x" + this._gameData.payoutMultiplier;
            this._fsTextGlow.text = "x" + this._gameData.payoutMultiplier;
            this.showMultiplier();
        }
    }

    private onDataParsed(data: TombOfAkhenatenParsedGameData | TombOfAkhenatenParsedInitData): void {
        this._gameData = data;
    }

    private onNewGameRound(): void{
        if(!(this.isBonusGame())){
            this.hideMultiplier();
        }
    }

    private createFSMultiplier():void {
        this._fsMultiplier = new BitmapCountUp({style: TombOfAkhenatenTextStyles.BONUS_GAME_BIG_MULTIPLIER});
        this._fsMultiplier.maxTextWidth = TombOfAkhenatenGameConfig.instance.REEL_AREA_WIDTH;
        this._fsMultiplier.visible = false;
        StageManager.getLayer(TombOfAkhenatenGameConfig.instance.LAYERS.MULTIPLIERS.name).addChild(this._fsMultiplier);
    }

    private updateFSMultiplier(multValue: number, isAbort: boolean):void {
        let playMultiplierSounds: boolean = false,
            reducedTime: boolean = GameSetting.isFastSpin || isAbort;

        if(this._isGameStarted && this.isBonusGame() && multValue > 1){
            playMultiplierSounds = true;
        }

        const scaleTo:number = 2,
            pos:number[] = [(TombOfAkhenatenGameConfig.instance.REEL_AREA_WIDTH / 2), TombOfAkhenatenGameConfig.instance.REEL_AREA_HEIGHT];

        this._fsMultiplier.visible = (multValue > 1);
        this._fsMultiplier.text = "x" + multValue;
        this._fsMultiplier.position.set(pos[0], pos[1]);
        this._fsMultiplier.pivot.set(0, 80);
        this._fsMultiplier.scale.set(4);
        this._fsMultiplier.anchor = 0.5;

        if (playMultiplierSounds) {
            SoundManager.playBigMultiplierSound(multValue);
        }

        EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.HIDE_WIN_AMOUNT_BEFORE_MULT_UPDATE));

        TweenLite.to(this._fsMultiplier.scale, reducedTime ? 0.02 : 0.05, {
            x : scaleTo,
            y : scaleTo,
            delay: 0.1,
            onComplete : () => {
                TweenLite.to(() => {}, 0.3, {
                    delay: reducedTime ? 0.1 : 0.5,
                    onComplete : () => {
                        if(playMultiplierSounds){
                            SoundManager.playMultiplierUpSound(multValue);
                        }

                        TweenLite.to(this._fsMultiplier, reducedTime ? 0.2 : 0.3, {
                            x : this.x,
                            y : this.y
                        });
                        TweenLite.to(this._fsMultiplier.scale, reducedTime ? 0.2 : 0.3, {
                            x : 0,
                            y : 0,
                            onComplete : () => {
                                this._fsMultiplier.visible = false;
                                this._fsText.text = "x" + multValue;
                                this._fsTextGlow.text = "x" + multValue;
                                this._fsSmokeAnim.getAnimationAutoShowHide(true, true);
                                this.showMultiplier();
                            }
                        });
                    }
                });
            }
        });
    }
}